import React, { useState, useEffect } from 'react';
//import {useLocation } from 'react-router-dom';

import "../PaginaCustomer.css";

//import parse from 'html-react-parser';

//import { language } from '../WEBContent/Language';

import {
    set_language,

} from '../../../Utils';

//import CookieConsent from "react-cookie-consent";

//import * as Hosts from "../../../Hosts";

const GoTopButton = (props) => {

    const [template, set_template] = useState('');
    const [theme, set_theme] = useState('');

    const [/*lang*/, set_lang] = useState('pt');

    const [ showGoTop, setShowGoTop ] = useState( false )

    const handleVisibleButton = () => {
        setShowGoTop( window.scrollY > 50 )
    }
    
    const handleScrollUp = () => {
        window.scrollTo( { left: 0, top: 0, behavior: 'smooth' } )
    }

    useEffect(() => {

        if(props.item !== undefined && props.item !== null && props.item !== '') {
            set_template(props.item.template)
            set_theme(props.item.theme)
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
        }
        else {
            set_lang(localStorage.getItem('lang'))
        }

        window.addEventListener( 'scroll', handleVisibleButton )

    }, [props])

    return (

        <button className={ (showGoTop ? 'scroll-top-wrapper show' : 'scroll-top-wrapper') + ' ' + (template + ' ' + theme) } type="button" aria-label="scroll to top" onClick={ handleScrollUp }>
            <span>
                <i className="bi bi-arrow-up"></i>
            </span>
        </button>
    )
};
export default GoTopButton;